export default __webpack_public_path__ + "static/contact-map-31efdbb573959cd70bd857de72c04399.png";